export default {
    items: [
        {
            name: 'Dashboard',
            url: '/dashboard',
            icon: 'fts-icon-dashboard',
            permission: new Array('DASHBOARD', 'SUPER_ADMIN_PANEL')
        },
        {
            name: 'SIM Activation',
            url: '/sim/active',
            icon: 'fts-icon-sims',
            permission: new Array('ACTIVATION_COLD_STOCK_READ', 'ACTIVATION_COLD_STOCK_WRITE','COLD_STOCK_MANAGEMENT','ORDER_MANAGEMENT','PERFORM_ACTIONS_ON_COMPANY','SUPER_ADMIN_PANEL')
        },
        {
            name: 'SIM Management',
            url: '/sim/management',
            icon: 'fts-icon-group-sims',
            permission: new Array('SIM_MANAGEMENT_READ','SIM_MANAGEMENT_WRITE','PERFORM_ACTIONS_ON_COMPANY','SUPER_ADMIN_PANEL')
        },
        {
            name: 'Cold Stock',
            url: '/cold-stock',
            icon: 'fts-icon-cold-stock',
            permission: new Array('ACTIVATION_COLD_STOCK_READ','ACTIVATION_COLD_STOCK_WRITE','COLD_STOCK_MANAGEMENT','ORDER_MANAGEMENT','SUPER_ADMIN_PANEL','PERFORM_ACTIONS_ON_COMPANY')
        },
        {
            name: 'Bulk SIM Operations',
            url: '/bulk/bulk-select-carrier',
            icon: 'fts-icon-bulk',
            permission: new Array('SIM_MANAGEMENT_READ','SIM_MANAGEMENT_WRITE','PERFORM_ACTIONS_ON_COMPANY','SUPER_ADMIN_PANEL')
        },
        {
            name: 'Transaction Logs',
            url: '/transaction',
            icon: 'fa fa-exchange',
            permission: new Array('TRANSACTIONS_READ', 'TRANSACTIONS_WRITE','PERFORM_ACTIONS_ON_COMPANY','SUPER_ADMIN_PANEL')
        },
        {
            name: 'Order',
            url: '/order',
            icon: 'fts-icon-cart',
            permission: new Array('ORDERS_READ', 'ORDERS_WRITE','ORDERS_CREATE','ORDER_MANAGEMENT','PERFORM_ACTIONS_ON_COMPANY','SUPER_ADMIN_PANEL'),
            children: [
                {
                    name: 'Order SIMs',
                    url: '/order/sims',
                    permission: new Array('ORDERS_WRITE', 'ORDERS_CREATE','ORDER_MANAGEMENT','PERFORM_ACTIONS_ON_COMPANY','SUPER_ADMIN_PANEL')
                },
                {
                    name: 'Order History',
                    url: '/order/history',
                    permission: new Array('ORDERS_READ', 'ORDERS_WRITE','ORDERS_CREATE','ORDER_MANAGEMENT','PERFORM_ACTIONS_ON_COMPANY','SUPER_ADMIN_PANEL')
                }
            ]
        },
        {
            name: 'Reports',
            url: '/reporting',
            icon: 'fa fa-file',
            permission: new Array('REPORTS_READ','REPORTS_WRITE','PERFORM_ACTIONS_ON_COMPANY','SUPER_ADMIN_PANEL')
        },
        {
            name: 'Billing',
            url: '/billing/history',
            icon: 'fa fa-money',
            permission: new Array('BILLING_READ','BILLING_WRITE','PERFORM_ACTIONS_ON_COMPANY','SUPER_ADMIN_PANEL'),
            children: [
                {
                    name: 'Balance & Pool',
                    url: '/balance-and-pools',
                    permission: new Array('BILLING_READ','BILLING_WRITE','PERFORM_ACTIONS_ON_COMPANY','SUPER_ADMIN_PANEL')
                },
                {
                    name: 'Billing Transactions',
                    url: '/billing/transactions',
                    permission: new Array('BILLING_READ','BILLING_WRITE','PERFORM_ACTIONS_ON_COMPANY','SUPER_ADMIN_PANEL')
                },
                {
                    name: 'Payment History',
                    url: '/billing/payment-history',
                    permission: new Array('BILLING_READ','BILLING_WRITE','PERFORM_ACTIONS_ON_COMPANY','SUPER_ADMIN_PANEL')
                }
            ]
        },
        // {
        //     name: 'Affiliate Program',
        //     url: '/affiliate-program',
        //     icon: 'fa fa-pie-chart',
        //     permission: 'AFFILIATE_PROGRAM_READ'
        // },
        {
            name: 'Alerts',
            url: '/alerts',
            icon: 'fa fa-bell',
            class: 'sidebarnav-alerts',
            permission: new Array('ALERTS_READ','ALERTS_WRITE','PERFORM_ACTIONS_ON_COMPANY','SUPER_ADMIN_PANEL')
        },
        {
            name: 'Settings',
            url: '/setttings',
            icon: 'fts-icon-gear',
            permission: null,
            children: [
                {
                    name: 'Company',
                    url: '/settings/company',
                    permission: new Array('COMPANY_SETTINGS_READ','COMPANY_SETTINGS_WRITE','PERFORM_ACTIONS_ON_COMPANY','SUPER_ADMIN_PANEL')
                },
                {
                    name: 'Users',
                    url: '/settings/users',
                    permission: new Array('USERS_READ','USERS_WRITE','PERFORM_ACTIONS_ON_COMPANY','SUPER_ADMIN_PANEL')
                },
                {
                    name: 'Payments',
                    url: '/settings/payment',
                    permission: new Array('BILLING_READ','BILLING_WRITE','PERFORM_ACTIONS_ON_COMPANY','SUPER_ADMIN_PANEL')
                },
                {
                    name: 'Plans',
                    url: '/settings/plans',
                    permission: new Array('PLANS_READ','PLANS_WRITE','PERFORM_ACTIONS_ON_COMPANY','SUPER_ADMIN_PANEL')
                },
                {
                    name: 'Tags',
                    url: '/settings/tags',
                    permission: new Array('CUSTOM_FIELDS_AND_TAGS_READ','CUSTOM_FIELDS_AND_TAGS_WRITE','PERFORM_ACTIONS_ON_COMPANY','SUPER_ADMIN_PANEL')
                },
                {
                    name: 'Custom Fields',
                    url: '/settings/custom-fields',
                    permission: new Array('CUSTOM_FIELDS_AND_TAGS_READ','CUSTOM_FIELDS_AND_TAGS_WRITE','PERFORM_ACTIONS_ON_COMPANY','SUPER_ADMIN_PANEL')
                }
            ]
        },
        {
            name: 'Help & Updates',
            url: '/help',
            icon: 'fa fa-life-ring',
            permission: null
        }
    ]
}
